export class LogOnRq {

    Password:string = "";
    AppVersion:string = "1";
    AppComments:string="";
    UserName:string = "";
    AppKey:string = "";
    

}
